import React from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStylesForTesting } from '../../../../../Components/helper';

export function BorderStyleConfig({ obj, handleBorderStyle }) {
  const { t } = useTranslation('common');

  const options = [
    { value: '1px', label: 'Solid (1px)' },
    { value: '3px', label: 'Solid (3px)' },
    { value: '5px', label: 'Solid (5px)' },
    { value: 'dotted', label: 'Dotted' },
    { value: 'dashed', label: 'Dashed' },
  ];
  const foundBorder = options?.find((ele) => ele.value === obj?.otherConfiguration?.border_style);
  return (
    <div className="pl-0 pr-2 w-200px">
      <Select
        name="border_style"
        options={options}
        value={foundBorder}
        styles={customStylesForTesting}
        className="common-select"
        classNamePrefix="common-select"
        onChange={(e) => handleBorderStyle(e, 'border_style')}
        placeholder={t('CUSTOM_MODULES.LIBRARY.CONTROL_CONFIG.BORDER_STYLE.STYLE')}
        menuPosition="fixed"
      />
    </div>
  );
}

export default BorderStyleConfig;
